export default {"src":"/_next/static/media/Facebook.a971c99c.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};